import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const getReports = (storeId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-delivery-collection/' + storeId,
    headers: getHeaders(),
  });
};

export const getAdminStoreWiseReports = (storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-delivery-collection/' + storeId,
    headers: getHeaders(),
    data: JSON.stringify(data)
  });
};